import { StatusBar } from '@capacitor/status-bar';
import { Style as StatusBarStyle } from '@capacitor/status-bar/dist/esm/definitions';
import { isApplicationRunningOniOS } from 'acscp/components/common/helpers/isApplicationRunningOniOS';
import { Capacitor } from '@capacitor/core';

/**
 * Capacitor's StatusBar.setOverlaysWebView does not set the safe-area-inset-* CSS properties on Android, which means that we
 * can't use a transparent status bar, so we set an appropriate opaque background for it instead.
 */
export const setStatusBarForLightContent = () => {
    if (Capacitor.isNativePlatform()) {
        void StatusBar.setStyle({style: StatusBarStyle.Light});
        if (!isApplicationRunningOniOS()) {
            void StatusBar.setBackgroundColor({color: '#FFFFFF'});
        }
    }
};

/**
 * @see setStatusBarForLightContent
 */
export const setStatusBarForDarkContent = () => {
    if (Capacitor.isNativePlatform()) {
        void StatusBar.setStyle({style: StatusBarStyle.Dark});
        if (!isApplicationRunningOniOS()) {
            void StatusBar.setBackgroundColor({color: '#4D4D4D'});
        }
    }
};
